import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Error from './components/Error';

// Redirect URL Here

import BlogRed from './components/redirectURL/BlogRed';
import TermAndConditions from './components/redirectURL/termandconditions';
import PrivacyPolicy from './components/redirectURL/privacyPolicy';
import RefundsAndCancellations from './components/redirectURL/refundsAndCancellations';
import InformationPage from './components/Institute/Information/InformationPage';

import ExamCourses from './components/redirectURL/examCourses';
import SkillCourses from './components/redirectURL/SkillCourses';
import CategoryCourses from './components/redirectURL/CategoryCourses';
// Redirect URL Here

import Loader from './components/Helper/Loader';
import ScrollToTop from './components/Helper/ScrollToTop';
import InstituteHome from './components/Institute';
import Calendar from './components/Institute/Calendar';
import CategorySingle from './components/Institute/CategorySingle';
import AllCourses from './components/Learn/AllCourses';


import CourseDetailNew from './components/Learn/CourseDetail';
import CourseStudent from './components/Learn/CourseStudent';
import VideoCourseDetail from './components/Institute/VideoCourseDetail';
import VideoCoursePlay from './components/Institute/VideoCoursePlay';
import AboutUs from './components/Institute/AboutUs';

import Blog from './components/Institute/Blog';
import BlogSingle from './components/Institute/Blog/BlogSingle';
import ContactUs from './components/Institute/ContactUs';
import StudentDeleteAccount from './components/Students/deleteAccount';

import Information from './components/Institute/Information';
import Faq from './components/Institute/Faq';
import LearnHome from './components/Learn';

// Instructor Panel
import Instructorprofile from './components/Instructor/profile';
import Instructor from './components/Instructor';
import InstructorRegister from './components/Instructor/pages/Register';
import CreateBlog from './components/Instructor/pages/createblog';

import OfficeViewer from './components/readers/officeViewer';
import PdfViewer from './components/readers/pdfViewer';

import CreateCourse from './components/Instructor/pages/createcourse';
import InstructorDashboard from './components/Instructor/pages/Dashboard';

// import InstructorLogin from './components/Instructor/pages/Login';
import RequestasTeam from './components/Institute/pages/bookteamlearn';
import Careers from './components/Institute/pages/Careers';
// Instructor Panel

// administrator Login
import AdminLogin from './components/administrator/pages/Login';
import AdminDashboard from './components/administrator/pages/Dashboard';
// administrator Login

// Student Panel
import UserRegister from './components/Students/pages/Register';
// import UserLogin from './components/Students/pages/Login';
import StudentDashboard from './components/Students/pages/Dashboard';

// CheckOut

import Ordersummary from './components/Checktout/OrderSummary';
// import MakePayment from './components/Checktout/MakePayment';
import GiftCourse from './components/Checktout/GiftCourse';
import Invoice from './components/Invoice/Invoice';
import Certificate from './components/certificate/file.js';
import AdminLayout from './components/layout/admin';
import ListOrders from './components/administrator/pages/Dashboard/orders/listing';
import ViewOrder from './components/administrator/pages/Dashboard/orders/view';

function RoutesHere() {
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        window.scrollTo(0, 0);
    });
    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 400);
    });
    return (
        <>
            {loading && (
                <div className={`appie-loader ${loading ? 'active' : ''}`}>
                    <Loader />
                </div>
            )}
            <div className={`appie-visible ${loading === false ? 'active' : ''}`}>
                {/* <Router basename="/docsta/learn"> */}
                <Router>
                    <ScrollToTop>
                        <Routes>
                            <Route exact path="/" element={<LearnHome />} />                            
                            <Route exact path="/invoice/:InvoiceID" element={<Invoice />} />
                            <Route exact path="/certificate/:cartID" element={<Certificate />} />
                            <Route exact path="/institute-old" element={<InstituteHome />} />
                            <Route exact path="/calendar" element={<Calendar />} />
                            <Route exact path="/category-single" element={<CategorySingle />} />

                            <Route exact path="/courses" element={<AllCourses />} />
                            <Route exact path="/courses/:MainCatID" element={<AllCourses />} />
                            <Route exact path="/category/:slug" element={<CategoryCourses />} />
                            <Route exact path="/courses-:TypeofCourse" element={<AllCourses />} />
                            <Route exact path="/course-:CourseSlug" element={<CourseDetailNew />} />
                            <Route exact path="/course/:CourseSlug" element={<CourseDetailNew />} />
                            <Route exact path="/eproducts/:CourseSlug" element={<CourseDetailNew />} />
                            <Route
                                exact
                                path="/instructor/profile/:Slug"
                                element={<Instructorprofile />}
                            />
                            <Route
                                exact
                                path="/courseStudent/:CourseSlug"
                                element={<CourseStudent />}
                            />
                            <Route
                                exact
                                path="/videocourse/:CourseSlug"
                                element={<VideoCourseDetail />}
                            />
                            <Route
                                exact
                                path="/videocourse/play/:CourseSlug"
                                element={<VideoCoursePlay />}
                            />
                            <Route exact path="/about-us" element={<AboutUs />} />
                            <Route exact path="/blogs" element={<BlogRed />} />
                            <Route exact path="/blog" element={<Blog />} />
                            <Route exact path="/blogs/:CatID" element={<Blog />} />
                            <Route exact path="/blog/:BlogID" element={<BlogSingle />} />
                            <Route exact path="/contact-us" element={<ContactUs />} />
                            <Route
                                exact
                                path="/user/delete-my-account"
                                element={<StudentDeleteAccount />}
                            />                          
                           
                            <Route exact path="/information/:InfoTitle" element={<Information />} />
                            <Route
                                exact
                                path="/terms-and-conditions"
                                element={<TermAndConditions />}
                            />
                            <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
                            <Route
                                exact
                                path="/refunds-and-cancellations"
                                element={<RefundsAndCancellations />}
                            />
                            <Route
                                exact
                                path="/certifications"
                                element={<InformationPage pageName="certifications" />}
                            />
                            <Route exact path="/skill-courses" element={<SkillCourses />} />
                            <Route exact path="/exam-courses" element={<ExamCourses />} />
                            <Route exact path="/faq" element={<Faq />} />
                            {/* <Route exact path="/bookaclass" element={<BookaClass />} /> */}
                            <Route exact path="/request-as-team" element={<RequestasTeam />} />
                            <Route exact path="/careers" element={<Careers />} />
                            <Route exact path="/learn" element={<LearnHome />} />
                            <Route exact path="/instructor" element={<Instructor />} />
                            <Route exact path="/instructor" element={<Instructor />} />
                            
                            <Route exact path="/create-course" element={<CreateCourse />} />
                            
                            <Route exact path="/create-blog" element={<CreateBlog />} />
                            <Route exact path="/office-viewer" element={<OfficeViewer />} />
                            <Route exact path="/pdf-viewer" element={<PdfViewer />} />
                            <Route
                                exact
                                path="/instructor-register"
                                element={<InstructorRegister />}
                            />
                            <Route exact path="/user/register" element={<UserRegister />} />
                            <Route exact path="/checkout/cart" element={<Ordersummary />} />
                            {/* <Route exact path="/checkout/payment" element={<MakePayment />} /> */}
                            <Route exact path="/checkout/giftCourse" element={<GiftCourse />} />
                            <Route
                                exact
                                path="/user/register/:regToken"
                                element={<UserRegister />}
                            />
                            <Route exact path="/user/login" element={<StudentDashboard />} />
                            <Route
                                exact
                                path="/instructor-login"
                                element={<InstructorDashboard />}
                            />
                            <Route exact path="/admin-login" element={<AdminLogin />} />
                            <Route exact path="/user/dashboard" element={<StudentDashboard />} />
                            <Route
                                exact
                                path="/user/page/:PageName"
                                element={<StudentDashboard />}
                            />
                            <Route
                                exact
                                path="/instructor-dashboard"
                                element={<InstructorDashboard />}
                            />
                            <Route
                                exact
                                path="/instructor-dashboard-:PageName"
                                element={<InstructorDashboard />}
                            />
                            <Route
                                exact
                                path="/instructor/page/:PageName"
                                element={<InstructorDashboard />}
                            />
                            <Route exact path="/admin-dashboard" element={<AdminDashboard />} />
                            <Route
                                exact
                                path="/admin/page/:PageName"
                                element={<AdminDashboard />}
                            />
                            <Route
                                exact
                                path="/admin/orders"
                                element={
                                    <AdminLayout>
                                        <ListOrders />
                                    </AdminLayout>
                                }
                            />
                            <Route
                                exact
                                path="/admin/orders/:id"
                                element={
                                    <AdminLayout>
                                        <ViewOrder />
                                    </AdminLayout>
                                }
                            />
                            <Route path="admin-dashboard-:PageName" element={<AdminDashboard />} />
                            <Route exact path="/error" element={<Error />} />
                            <Route path="*" element={<Error />} />
                            <Route path="institute" element={<Navigate to="/" />} />
                        </Routes>
                        {/* <Navigate from="/institute" to="/" />  <Route path="*" element={<Navigate to="/Error" />} /> */}
                    </ScrollToTop>
                </Router>
            </div>
        </>
    );
}

export default RoutesHere;
